import { render, staticRenderFns } from "./onboarding-view.vue?vue&type=template&id=14f74762&scoped=true"
import script from "./onboarding-view.vue?vue&type=script&lang=js"
export * from "./onboarding-view.vue?vue&type=script&lang=js"
import style0 from "./onboarding-view.vue?vue&type=style&index=0&id=14f74762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f74762",
  null
  
)

export default component.exports